export const languages = ['en-US'];
export const defaultLanguage = languages[0];
